import React, { useEffect, useRef, useState } from "react";
import Box from "../../components/Box";
import { TableauEmbed } from "@stoddabr/react-tableau-embed-live";

const handleDevice = (width: number) => {
  if (width <= 480) {
    return "phone";
  }
  if (width <= 768) {
    return "tablet";
  } else {
    return "desktop";
  }
};

function Network() {
  const vizRef = useRef<any>();
  const [device, setDevice] = useState<"phone" | "tablet" | "desktop">(
    handleDevice(window?.innerWidth)
  );

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const updateWidth = (ev: Event) => {
    const target = ev.target as Window;

    if (vizRef && vizRef.current) {
      const viz = vizRef.current;
      setDevice(handleDevice(target.innerWidth));
      viz.setFrameSize(target.innerWidth, target.innerHeight);
    }
  };

  useEffect(() => {
    window.addEventListener("resize", updateWidth);
    return () => {
      window.removeEventListener("resize", updateWidth);
    };
  }, [updateWidth]);

  return (
    <Box>
      <TableauEmbed
        sourceUrl="https://eu-west-1a.online.tableau.com/#/site/tableauforcarrefour/views/CockpitdePerformance/HomepagePDM"
        ref={vizRef}
        width={window?.innerWidth}
        height={window?.innerHeight}
        device={device}
      />
    </Box>
  );
}

export default Network;
